import { Navigate, Route, Routes, RouterProvider, createBrowserRouter } from 'react-router-dom';
import { LayoutPublic } from '../components/LayoutPublic';
import { HomePage, InstructivosPage, LoginPage, RegisterPage, UserRequestPage, SolicitudEntidadPage, EntidadRegistroPage, ForgotPasswordPage, ResetPasswordPage } from '../pages';
import { useContext } from 'react';
import { AuthContext } from '../context/authContext';

export const PublicRoutes = () => {
    const { isAuthenticated } = useContext(AuthContext);

    return (
        <LayoutPublic>
            <div className="flex flex-col flex-1 h-full bg-white dark:bg-gray-900 dark:text-white">
                <Routes>
                    <Route path='/' element={<div className="h-full overflow-hidden"><HomePage /></div>} />
                    <Route path='login' element={isAuthenticated ? <Navigate to='/inicio' replace /> : <LoginPage/>} />
                    <Route path='register' element={<RegisterPage />} />
                    <Route path='solicitud-usuario' element={<UserRequestPage />} />
                    <Route path='solicitud-entidad' element={<SolicitudEntidadPage />} />
                    <Route path='instructivos' element={<InstructivosPage />} />
                    <Route path='/registro-entidad' element={<EntidadRegistroPage />} />
                    <Route path='/forgot-password' element={<ForgotPasswordPage />} />
                    <Route path='/reset-password' element={<ResetPasswordPage />} />
                    {/*<Route path='update/:token' element={<UpdatePage />}  />*/}
                    <Route path='*' element={<Navigate to='/login' replace />} />
                </Routes>
            </div>
        </LayoutPublic>
    );
};

